module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }